export default function RandomizerNode({ id, data }) {
    const randomizerOutputs = data?.randomizerOutputs || [
        { id: 'r0', percent: 50 },
        { id: 'r1', percent: 50 },
    ];
    const total = randomizerOutputs.reduce((s, o) => s + (parseFloat(o.percent) || 0), 0);
    const sumOk = Math.abs(total - 100) < 0.01;

    return (
        <div className="mt-2 space-y-2">
            <div className="space-y-1">
                {randomizerOutputs.map((output, index) => (
                    <div key={output.id} className="flex items-center gap-1 bg-black/30 border border-white/[0.06] rounded-md p-1.5">
                        <i className="fas fa-grip-vertical text-white/30 flex-shrink-0 text-[10px]" />
                        <span className="text-[10px] text-sky-300 shrink-0">#{index + 1}</span>
                        <input type="number" min="1" max="99" step="1"
                            className="no-step flex-1 bg-transparent border-0 text-white text-xs p-1 text-center focus:outline-none min-w-0"
                            value={output.percent}
                            onChange={(e) => {
                                const updated = randomizerOutputs.map((o, i) =>
                                    i === index ? { ...o, percent: parseFloat(e.target.value) || 0 } : o
                                );
                                data?.onChangeRandomizer?.(id, { randomizerOutputs: updated });
                            }} />
                        <span className="text-[10px] text-gray-400 shrink-0">%</span>
                        {randomizerOutputs.length > 2 && (
                            <button type="button" className="p-0.5 rounded text-white/40 hover:text-red-500 flex-shrink-0"
                                onClick={() => {
                                    const updated = randomizerOutputs.filter((_, i) => i !== index);
                                    data?.onChangeRandomizer?.(id, { randomizerOutputs: updated });
                                }}>
                                <i className="fas fa-times text-[10px]" />
                            </button>
                        )}
                    </div>
                ))}
            </div>

            {randomizerOutputs.length < 5 && (
                <button type="button"
                    className="w-full flex items-center justify-center gap-1 py-1.5 rounded-md border border-dashed border-white/[0.08] text-white/40 hover:text-white hover:border-sky-400 transition-colors text-xs"
                    onClick={() => {
                        const newId = `r${Date.now()}`;
                        data?.onChangeRandomizer?.(id, { randomizerOutputs: [...randomizerOutputs, { id: newId, percent: 0 }] });
                    }}>
                    <i className="fas fa-plus text-[10px] mr-1" />Adicionar saída
                </button>
            )}

            <div className={`text-[10px] text-center font-semibold py-1 ${sumOk ? 'text-sky-400' : 'text-red-400'}`}>
                Total: {total.toFixed(0)}% {sumOk ? '✓' : '(ideal: 100%)'}
            </div>
        </div>
    );
}
